<template>
  <div :id="id"
       class="tab-pane fade"
       role="tabpanel"
       :class="{'active show': active}"
       :aria-labelledby="id + '-tab'">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VTabItem',
  data() {
    return {}
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "VTabs";
</style>
